import {
  DEFAULT_PAGE_SIZE,
  type PAGE_SIZE_OPTIONS,
} from '@/shared/constants/pagination';
import { useCallback, useMemo, useState } from 'react';

type PageSizeOption = (typeof PAGE_SIZE_OPTIONS)[number];

/**
 * 목록 화면 공통 페이지·페이지 크기 상태.
 * API는 0-based page를 쓰므로 `pageable`을 그대로 query에 넘긴다.
 */
export const useListPagination = (initialPageSize: number = DEFAULT_PAGE_SIZE) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSizeState] = useState(initialPageSize);

  const setPageSize = useCallback((size: number) => {
    setPageSizeState(size);
    setPage(1);
  }, []);

  const pageable = useMemo(
    () => ({ page: page - 1, size: pageSize }),
    [page, pageSize],
  );

  return {
    page,
    setPage,
    pageSize,
    setPageSize,
    pageable,
  };
};

export type { PageSizeOption };
